module.exports = __webpack_public_path__ + "static/media/player1-button.a921ec12.png";